import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './goal-progress-update-loading.style';

export const GoalProgressUpdateLoading: React.FC = () => (
  <Styled.Container>
    <CircularProgress />
  </Styled.Container>
);
